import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

import graph from "../assets/images/graph.png";

import headerMobile from "../assets/images/header-mobile.png";

import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import aboutImg from "../assets/images/about-mobile-crop.png";
import arrowOutward from "../assets/images/arrow_outward.png";

import appleBtn from "../assets/images/appleBtn-black.png";
import googleBtn from "../assets/images/googleBtn-black.png";

import graphBg from "../assets/images/graph-bg.png";
import downloadImg from "../assets/images/downloadApp.png";

import transaction1 from "../assets/images/transaction1.png";
import transaction2 from "../assets/images/transaction2.png";
import transaction3 from "../assets/images/transaction3.png";
import transaction4 from "../assets/images/transaction4.png";
import transaction5 from "../assets/images/transaction5.png";

import funds from "../assets/images/funds.png";
import loans from "../assets/images/loans.png";
import support from "../assets/images/cutomer-support.png";
import withdrawls from "../assets/images/withdraws.png";

const HomePage = () => {
  const [activeTab, setActiveTab] = useState("mission");

  const tabs = [
    { id: "mission", label: "Our Mission" },
    { id: "vision", label: "Our Vision" },
    { id: "history", label: "Our History" },
    { id: "subscription", label: "Subscription" },
  ];

  const tabContent = {
    mission: [
      "But in certain circumstances and owing to the claims",
      "Pleasure is to be welcomed and every pain avoided.",
      "These cases are perfectly simple easy to distinguish.",
    ],
    vision: [
      "Vision: Building a secure financial future for all.",
      "We envision a world of decentralized banking access.",
      "Empowering people through innovative banking tools.",
    ],
    history: [
      "Founded in 1990, with a legacy of trust.",
      "Expanded globally with modern financial solutions.",
      "Pioneered smart digital banking in the MENA region.",
    ],
    subscription: [
      "Subscribe to our newsletter for the latest updates.",
      "Get exclusive access to financial insights and offers.",
      "Join thousands of subscribers today!",
    ],
  };

  const navigate = useNavigate();
  const [scrollX, setScrollX] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  return (
    <div>
      {/* Header */}
      <div className="img1">
        <Header />
        {/* Banner Sec */}
        <div className="header-banner" id="home">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-12 main-header" style={{ marginTop: "80px" }}>
                <div className="header-txt1">
                  <div
                    className="position-relative"
                    data-aos="fade-right"
                    data-aos-delay="100"
                  >
                    <h1
                      className="inter-font"
                      style={{ color: "#E5E5E5", fontSize: "40px" }}
                    >
                      Manage your investments <br className="br br-res" /> on the go
                    </h1>
                    <p style={{ color: "gray" }}>
                      Deposit, withdraw, request a loan and manage your <br className="br" />
                      complete investment portfolio
                    </p>
                  </div>
                </div>
                <div>
                  <button
                    type="submit"
                    className="btn-common fw-bold py-2 shadow"
                    data-aos="fade-right"
                    data-aos-delay="200"
                  >
                    Download Our App
                  </button>
                </div>
                <div
                  className="row graph mt-5 rounded-4 px-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  style={{ background: "#222222", height: "121px", maxWidth: "450px" }}
                >
                  <div className="col-md-6 col-6 d-flex align-items-center justify-content-center">
                    <div className="d-flex flex-column align-items-start">
                      <span style={{ color: "#FDCD26", marginBottom: "8px" }}>
                        Clients
                      </span>
                      <div className="d-flex align-items-center header-strip-txt">
                        <h3
                          style={{
                            color: "white",
                            marginBottom: 0,
                            fontSize: "2.1rem",
                          }}
                        >
                          250k
                        </h3>
                        <img
                          src={graph}
                          alt="graph"
                          style={{
                            width: "35px",
                            height: "25px",
                            marginLeft: "10px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-6 d-flex align-items-center justify-content-center">
                    <div className="d-flex flex-column align-items-start">
                      <span style={{ color: "#FDCD26", marginBottom: "8px" }}>
                        Years
                      </span>
                      <div className="d-flex align-items-center header-strip-txt">
                        <h3
                          style={{
                            color: "white",
                            marginBottom: 0,
                            fontSize: "2.1rem",
                          }}
                        >
                          20
                        </h3>
                        <img
                          src={graph}
                          alt="graph"
                          style={{
                            width: "35px",
                            height: "25px",
                            marginLeft: "10px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-4 col-4 d-flex align-items-center">
                    <div className="d-flex flex-column align-items-start">
                      <span style={{ color: "#FDCD26", marginBottom: "8px" }}>
                        Impact
                      </span>
                      <div className="d-flex align-items-center header-strip-txt">
                        <h3
                          style={{
                            color: "white",
                            marginBottom: 0,
                            fontSize: "2.1rem",
                          }}
                        >
                          85%
                        </h3>
                        <img
                          src={graph}
                          alt="graph"
                          style={{
                            width: "35px",
                            height: "25px",
                            marginLeft: "10px",
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* Right Side */}
              <div
                className="col-md-6 col-12"
                data-aos="fade-left"
                data-aos-delay="200"
              >
                <div className="carImg d-flex justify-content-center align-items-center flex-column">
                  <img
                    src={headerMobile}
                    style={{ width: "414px", height: "512px" }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us */}
      <div className="container" id="about">
        <div className="row my-5 rounded-4" style={{ background: "#2A2A2A", padding: "20px 0" }}>
          <div className="col-md-6 col-12 d-flex flex-column justify-content-center align-items-center">
            <div
              className="deals"
              style={{ width: "60%" }}
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <img src={aboutImg} style={{ width: "100%" }} alt="About GAT" />
            </div>
          </div>

          <div className="col-md-6 col-12 my-4">
            <div
              className="text-light rounded-4 p-4 about-section"
              data-aos="fade-left"
              data-aos-delay="100"
              style={{ background: "#222222", width: "90%" }}
            >
              <p data-aos="fade-up" data-aos-delay="200">
                Global Arabian Trading Bank
              </p>
              <h1
                data-aos="fade-up"
                data-aos-delay="250"
                className="fw-bolder"
                style={{ fontSize: "50px" }}
              >
                About GAT
              </h1>
              <p
                data-aos="fade-up"
                data-aos-delay="300"
                style={{ fontSize: "13px", color: "#BABABA" }}
              >
                Global Arabian Trading delivers consistent monthly income and strong annual growth through expertly managed, transparent investment strategies built on trust and reliability.
              </p>

              <div className="mt-5" data-aos="fade-up" data-aos-delay="350">
                <div className="d-flex gap-4 pb-2">
                  {tabs.map((tab) => (
                    <div
                      key={tab.id}
                      className={`tab-item ${
                        activeTab === tab.id ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        color: activeTab === tab.id ? "#F9C642" : "#606060",
                      }}
                    >
                      {tab.label}
                      {activeTab === tab.id && (
                        <div className="gradient-underline mt-1"></div>
                      )}
                    </div>
                  ))}
                </div>

                <p
                  style={{
                    fontSize: "13px",
                    color: "#BABABA",
                    marginTop: "1rem",
                  }}
                >
                  Global Arabian Trading delivers consistent monthly income and strong annual growth through expertly managed, transparent investment strategies built on trust and reliability.
                </p>

                {/* <ul className="ps-3 mt-3 about-right-section">
                  {tabContent[activeTab].map((item, index) => (
                    <li key={index} className="list-item mb-3">
                      <span className="arrow">→</span> {item}
                    </li>
                  ))}
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div
        className="container bottom text-light"
        id="whyChooseUs"
        style={{ marginTop: "100px" }}
      >
        <h2
          className="text-center whyTxt"
          data-aos="fade-up"
          data-aos-delay="100"
          style={{ fontSize: "65px", fontWeight: "800" }}
        >
          Why Choose Us
        </h2>
        <p 
          className="text-center" 
          data-aos="fade-up"
          data-aos-delay="150"
          style={{ color: "#BABABA" }}
        >
        Choose Global Arabian Trading for consistent monthly income from dividends, strong annual growth up to 30%, <br className="none" /> expert portfolio management, transparent strategies, and a client-focused approach built <br className="none" /> on trust and reliability.
        </p>
        <div className="row mt-5">
          <div className="col-md-3 mb-3" data-aos="fade-up" data-aos-delay="200">
            <div
              className="hover-card rounded-3 p-3 d-flex justify-content-center align-items-center flex-column"
              style={{ background: "#2D2D2D", height: "261px" }}
            >
              <div className="d-flex justify-content-between w-100 px-3">
                <img
                  src={funds}
                  style={{ width: "76px", height: "68px" }}
                  alt="funds"
                />
                <h1 style={{ fontSize: "65px" }}>01</h1>
              </div>

              <div className="w-100 px-3 mt-3 text-start">
                <p style={{ fontSize: "15px" }}>Manage your</p>
                <h3 style={{ fontSize: "21px" }}>Deposits</h3>

                {/* <div className="d-flex align-items-center gap-2 mt-2">
                  <img
                    src={arrowOutward}
                    className="p-1"
                    style={{
                      background: "#222",
                      width: "30px",
                      height: "30px",
                    }}
                    alt="arrow"
                  />
                  <span style={{ fontSize: "14px" }}>More</span>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3" data-aos="fade-up" data-aos-delay="300">
            <div
              className="hover-card rounded-3 p-3 d-flex justify-content-center align-items-center flex-column"
              style={{ background: "#2D2D2D", height: "261px" }}
            >
              <div className="d-flex justify-content-between w-100 px-3">
                <img
                  src={withdrawls}
                  style={{ width: "76px", height: "68px" }}
                  alt="Withdrawls"
                />
                <h1 style={{ fontSize: "65px" }}>02</h1>
              </div>

              <div className="w-100 px-3 mt-3 text-start">
                <p style={{ fontSize: "15px" }}>Manage your</p>
                <h3 style={{ fontSize: "21px" }}>Withdrawls</h3>

                {/* <div className="d-flex align-items-center gap-2 mt-2">
                  <img
                    src={arrowOutward}
                    className="p-1"
                    style={{
                      background: "#222",
                      width: "30px",
                      height: "30px",
                    }}
                    alt="arrow"
                  />
                  <span style={{ fontSize: "14px" }}>More</span>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3" data-aos="fade-up" data-aos-delay="400">
            <div
              className="hover-card rounded-3 p-3 d-flex justify-content-center align-items-center flex-column"
              style={{ background: "#2D2D2D", height: "261px" }}
            >
              <div className="d-flex justify-content-between w-100 px-3">
                <img
                  src={loans}
                  style={{ width: "76px", height: "68px" }}
                  alt="Loans"
                />
                <h1 style={{ fontSize: "65px" }}>03</h1>
              </div>

              <div className="w-100 px-3 mt-3 text-start">
                <p style={{ fontSize: "15px" }}>Request</p>
                <h3 style={{ fontSize: "21px" }}>Loans</h3>

                {/* <div className="d-flex align-items-center gap-2 mt-2">
                  <img
                    src={arrowOutward}
                    className="p-1"
                    style={{
                      background: "#222",
                      width: "30px",
                      height: "30px",
                    }}
                    alt="arrow"
                  />
                  <span style={{ fontSize: "14px" }}>More</span>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-3 mb-3" data-aos="fade-up" data-aos-delay="500">
            <div
              className="hover-card rounded-3 p-3 d-flex justify-content-center align-items-center flex-column"
              style={{ background: "#2D2D2D", height: "261px" }}
            >
              <div className="d-flex justify-content-between w-100 px-3">
                <img
                  src={support}
                  style={{ width: "60px", height: "68px" }}
                  alt="Customer Support"
                />
                <h1 style={{ fontSize: "65px" }}>04</h1>
              </div>

              <div className="w-100 px-3 mt-3 text-start">
                <p style={{ fontSize: "15px" }}>Access 24/7</p>
                <h3 style={{ fontSize: "21px" }}>Customer Support</h3>

                {/* <div className="d-flex align-items-center gap-2 mt-2">
                  <img
                    src={arrowOutward}
                    className="p-1"
                    style={{
                      background: "#222",
                      width: "30px",
                      height: "30px",
                    }}
                    alt="arrow"
                  />
                  <span style={{ fontSize: "14px" }}>More</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Services */}
      <div className="text-light" style={{ marginTop: "100px" }}>
        <h1
          className="text-center whyTxt"
          data-aos="fade-up"
          data-aos-delay="100"
          style={{ fontSize: "55px", fontWeight: "800" }}
        >
          Our Services
        </h1>
        <p 
          className="text-center mb-5 mt-4" 
          data-aos="fade-up"
          data-aos-delay="150"
        >
          To meet your wealth investment needs, GAT provides a wide range of
          services and plans. Our team <br className="br" /> of professionals is dedicated to
          providing you with the assistance & knowledge you need while <br />
          delivering outstanding outcomes. View our services below.
        </p>
        <div className="container">
          <div className="row">
            <div
              className="col-md-4 col-12 mb-3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div
                className="hover-card rounded-3 p-3"
                style={{ background: "rgba(255, 255, 255, 0.1)", height: "300px" }}
              >
                <h4 className="text-light">
                  Personalized Investement Guidence
                </h4>
                <p>
                  Our expert brokers are committed to providing personalised
                  investment guidance tailored to your unique financial goals
                  and risk tolerance. They will take time to understand your
                  individual circumstances and preferences, and develop a
                  customised investment strategy that aligns with your
                  objectives.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 col-12 mb-3"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div
                className="hover-card rounded-3 p-3"
                style={{ background: "rgba(255, 255, 255, 0.1)", height: "300px" }}
              >
                <h4 className="text-light">Portfolio Management</h4>
                <p>
                  Managing a well-diversified portfolio requires continuous
                  monitoring and adjustments. Our brokers will regularly review
                  your portfolio's performance, assess market conditions, and
                  make strategic recommendations for adjusting asset
                  allocations.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 col-12 mb-3"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div
                className="hover-card rounded-3 p-3"
                style={{ background: "rgba(255, 255, 255, 0.1)", height: "300px" }}
              >
                <h4 className="text-light">Risk Assessment & Mitigation</h4>
                <p>
                  Fully understanding and managing investment risks is essential
                  for long-term success. Our brokers carry out comprehensive
                  risk analyses, taking into account a number of factors such as
                  market volatility, economic conditions and sector-specific
                  risks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Mobile App */}
      <div
        className="container-fluid py-5 my-5 top"
        id="screenshort"
        style={{ background: "rgba(255, 255, 255, 0.1)" }}
      >
        <div className="text-center mb-4">
          <p className="text-light fw-bold" style={{ fontSize: "55px" }}>
            GAT Bank App
          </p>
          <h2 className="text-light" style={{ fontSize: "18px" }}>
            GAT Global Arabian Trading Bank app design screens and app travel
            for user
          </h2>
        </div>
        <div
          className="screenshots d-none d-md-flex justify-content-center align-items-end flex-wrap gap-3"
          style={{ marginTop: "80px" }}
        >
          <img
            src={transaction1}
            style={{ width: "178.5px", height: "388px", marginBottom: "60px" }}
            alt=""
            data-aos="fade-up"
            data-aos-delay="100"
          />
          <img
            src={transaction2}
            style={{ width: "204.8px", height: "445px", marginBottom: "35px" }}
            alt=""
            data-aos="fade-up"
            data-aos-delay="200"
          />
          <img
            src={transaction3}
            className="filter"
            style={{ width: "256.3px", height: "524px" }}
            alt=""
            data-aos="zoom-in"
            data-aos-delay="300"
          />
          <img
            src={transaction4}
            style={{ width: "204.8px", height: "445px", marginBottom: "35px" }}
            alt=""
            data-aos="fade-up"
            data-aos-delay="200"
          />
          <img
            src={transaction5}
            style={{ width: "178.5px", height: "388px", marginBottom: "60px" }}
            alt=""
            data-aos="fade-up"
            data-aos-delay="100"
          />
        </div>

        {/* Mobile View - Slider */}
        <div className="d-block d-md-none mt-5">
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper"
            style={{ paddingBottom: "40px" }}
          >
            <SwiperSlide className="d-flex justify-content-center">
              <img
                src={transaction1}
                style={{ width: "auto", height: "450px" }}
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="d-flex justify-content-center">
              <img
                src={transaction2}
                style={{ width: "auto", height: "450px" }}
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="d-flex justify-content-center">
              <img
                src={transaction3}
                style={{ width: "auto", height: "450px" }}
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="d-flex justify-content-center">
              <img
                src={transaction4}
                style={{ width: "auto", height: "450px" }}
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide className="d-flex justify-content-center">
              <img
                src={transaction5}
                style={{ width: "auto", height: "450px" }}
                alt=""
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      {/* Download our App */}
      <div
        className="container download-app-section rounded-5"
        id="downloadApp"
      >
        <div className="download-app-container">
          <div className="download-app-left">
            <h1
              data-aos="fade-right"
              data-aos-delay="100"
              className="download-app-title"
              style={{ fontSize: "55px", fontWeight: "800" }}
            >
              Download App
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="200"
              className="download-app-description"
            >
              Deposit, withdraw, request loan and manage you
              complete investments portfolio
            </p>
            <div className="download-buttons">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <img
                  src={appleBtn}
                  alt="Apple Store"
                  className="store-button"
                />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <img
                  src={googleBtn}
                  alt="Google Play"
                  className="store-button"
                />
              </a>
            </div>
          </div>
          <div
            className="download-app-right"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <img
              src={downloadImg}
              alt="App Preview"
              className="phone-preview"
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
